import { InjectionToken, makeEnvironmentProviders } from '@angular/core';

const APP_VERSION_KEY = 'APP_VERSION';

export const APP_VERSION_TOKEN = new InjectionToken<string>(APP_VERSION_KEY);

export const provideAppVersion = (appVersion: string) =>
  makeEnvironmentProviders([
    {
      provide: APP_VERSION_TOKEN,
      useValue: appVersion,
    },
  ]);
